/** Bosh sahifa sarlavhasi uchun vaqt: salomlashish (foydalanuvchi vaqtida), Toshkent va Dallas soati, qo'ng'iroq oynasi. */
import type { TFunction } from "i18next";
import { dayjs } from "@/lib/utils";
import { useNow } from "@/lib/useNow";
import { CALL_HOURS, callWindow } from "@/features/drivers/timezones";

const DALLAS = "America/Chicago";
const TASHKENT = "Asia/Tashkent";

export function useHomeClock(tz: string | null | undefined) {
  const now = useNow("minute");
  const d = dayjs(now);
  const hour = d.tz(tz || TASHKENT).hour();
  const greeting: "morning" | "afternoon" | "evening" = hour < 12 ? "morning" : hour < 18 ? "afternoon" : "evening";
  return {
    now: d,
    greeting,
    date: d.format("dddd, MMM D"),
    tashkent: d.tz(TASHKENT).format("HH:mm"),
    dallas: d.tz(DALLAS).format("h:mm A"),
    call: callWindow(now, DALLAS),
    callStart: `${CALL_HOURS[0]}:00`,
  };
}

/** "2 h 44 min" / "35 min" -- common:localTime kalitlari bilan */
export function durationLabel(minutes: number, tc: TFunction): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h ? tc("localTime.hm", { h, m }) : tc("localTime.m", { m });
}

/** "▲ 12" / "▼ 3" / "—" */
export function deltaChip(delta: number): { label: string; tone: "success" | "danger" | "muted" } {
  if (delta > 0) return { label: `▲ ${delta}`, tone: "success" };
  if (delta < 0) return { label: `▼ ${Math.abs(delta)}`, tone: "danger" };
  return { label: "—", tone: "muted" };
}

/** "▲ 12%" / "▼ 85%" -- foiz o'zgarishi (oldingi davr nol bo'lsa null) */
export function pctChip(current: number, previous: number): { label: string; tone: "success" | "danger" | "muted" } | null {
  if (!previous) return null;
  const pct = Math.round(((current - previous) * 100) / previous);
  if (pct > 0) return { label: `▲ ${pct}%`, tone: "success" };
  if (pct < 0) return { label: `▼ ${Math.abs(pct)}%`, tone: "danger" };
  return { label: "0%", tone: "muted" };
}

/** Manfiy summa tipografik minus bilan: −$337 */
export function signedMoney(value: number, format: (n: number) => string): string {
  return value < 0 ? `−${format(Math.abs(value))}` : format(value);
}
